

































import { Component, Prop, Emit, Mixins } from 'vue-property-decorator';
import SFormElement from './SFormElement.vue';
import SElementValidationErrors from './SElementValidationErrors.vue';

@Component({
  components: {
    SElementValidationErrors,
  },
})
export default class STextarea extends Mixins(SFormElement) {
  @Prop(String) public value!: string;
  @Prop({ type: Boolean, default: false }) private disabled?: boolean;

  @Prop({ default: 3 }) private rows!: number;

  @Prop({ type: Boolean, default: true }) private fullWidth!: boolean;
  @Prop({ type: Boolean, default: false }) private resizable?: boolean;
  @Prop({ type: Boolean, default: false }) private autoresizable?: boolean;

  @Prop({ type: Boolean, default: false }) private bordered?: boolean;

  private focused = false;

  private get listeners() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  @Emit('input')
  private handleInput(event: {target: HTMLInputElement}) {
    return event.target.value;
  }

  get displayedRows(): number {
    if (!this.autoresizable) return this.rows;

    // Consider limiting this so that user cannot go over
    // certain number of rows in browser?
    const totalRows = (this.value || '').split('\n').length;
    return totalRows < this.rows ? this.rows : totalRows;
  }
}
